/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vue Monica Refine Design
  Author: Riyan Kurniawan
  -- MONICA --
==========================================================================================*/


export default {
    addEventToCalendar({commit}, event) {
        commit('ADD_EVENT_TO_CALENDAR', event);
    },
    ediCalendarEvent({commit}, event) {
        commit('EDIT_CALENDAR_EVENT', event);
    },
    removeCalendarEvent({commit}, eventId) {
        commit('REMOVE_CALENDAR_EVENT', eventId);
    },
}
